import { compose, withHandlers } from 'recompose';

export const withCaptchaTokenHandlers = compose(
  withHandlers({
    handleRecaptchaChange:
      ({ recaptchaRef, setCaptchaToken, submitForm }) =>
      (captchaToken) => {
        if (captchaToken) {
          setCaptchaToken(captchaToken);
          setTimeout(() => {
            submitForm();
            recaptchaRef.current.reset();
          });
        }
      },
    handleRecaptchaError:
      ({ onError }) =>
      () =>
        onError(
          'Network Error: Please check your internet connection and try again.'
        ),
    triggerRecaptcha:
      ({ setTouched, validateForm, isValid, recaptchaRef, touched, errors }) =>
      (ev) => {
        ev.preventDefault();
        setTouched({ email: true, password: true, ...errors, ...touched });
        validateForm();

        if (isValid) {
          recaptchaRef.current.execute();
        }
      },
  })
);
